// src/components/admin/AdminSearchHeader.tsx
import React from "react";
import { Box, Typography, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export interface AdminSearchHeaderProps {
  title: string;
  count: number;
  searchPlaceholder: string;
  search: string;
  onSearchChange: (value: string) => void;
  showCreateButton?: boolean;
  createLabel?: string;
  onCreateClick?: () => void;
  createButtonWidth?: number | string;
}

const AdminSearchHeader: React.FC<AdminSearchHeaderProps> = ({
  title,
  count,
  searchPlaceholder,
  search,
  onSearchChange,
  showCreateButton,
  createLabel,
  onCreateClick,
  createButtonWidth,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
      <Typography sx={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "0.875rem", color: "#111111" }}>
        {title} ({count})
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          size="small"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: "#9CA3AF" }} />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            width: 240,
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#EAEAEA" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#9CA3AF" },
            "& .Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#EF2D3E" },
            "& input": { fontFamily: "'Inter', sans-serif", fontSize: "0.875rem" },
          }}
        />
        {showCreateButton && createLabel && onCreateClick && (
          <button
            onClick={onCreateClick}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              border: "none",
              background: "#EF2D3E",
              padding: "7px 14px",
              fontSize: "0.8125rem",
              fontWeight: 600,
              fontFamily: "'Inter', sans-serif",
              color: "#fff",
              cursor: "pointer",
              borderRadius: 8,
              minWidth: createButtonWidth as number | undefined,
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#d42635"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#EF2D3E"; }}
          >
            + {createLabel}
          </button>
        )}
      </Box>
    </Box>
  );
};

export default AdminSearchHeader;

